import chroma from 'chroma-js';
import { config } from 'config';
import { dataSeries, RANGE_MIXED, RANGE_NEGATIVE, RANGE_NULL, RANGE_POSITIVE, RANGE_ZERO } from '../dataSeries.js';
import { CLASSIFICATION_DISCRETE, CLASSIFICATION_EQUIDISTANT } from './classification.js';

export const color = {

  /**
   * Return a gradient (a chroma.js scale) consisting of a single color.
   */
  getSingle (data) {
    return chroma.scale([config.color.region.fill]).domain([data.min, data.max]);
  },

  /**
   * Create a color scale.
   * Note: We cannot evenly distribute the colors in the range to the numbers in the data series, e.g.:
   *   data series: 0, 0 10, 0, 0 should get the same color for each region except 10
   * @param {Number} [count] number of colors to create, only relevant when type = CLASSIFICATION_DISCRETE
   * @param {Number} type
   * @param {DataSeries} data
   * @return {Gradient} object with a scale and a type
   */
  getGradient (data, type, count) {
    let colors, scale, domain;
    switch (data.range) {
      case RANGE_POSITIVE:
        colors = this._getPositive();
        break;
      case RANGE_NEGATIVE:
        colors = this._getNegative();
        break;
      case RANGE_MIXED:
        colors = this._getMixed();
        break;
      case RANGE_ZERO:
        colors = [config.color.legend.posMin];
        break;
      case RANGE_NULL:
        colors = [config.color.region.none];
        break;
    }
    //let domain = [data.min, data.max];
    if (data.range === RANGE_MIXED) {
      let step = data.max / 100 / 2 - 0.01;
      let mid = 0 - step;
//let mid = 0;
      //scale = chroma.bezier(colors).scale();
      //scale.correctLightness();
      //scale = scale.colors(100)
      // ;
      /*
            domain = [];
      for (let i = 1; i < 100; i++) {
              domain.push(data.min + step * i)
            }*/
      domain = [data.min, mid, data.max];
    } else {
      domain = [data.min, data.max];
    }
    scale = chroma.scale(colors);
    scale = scale.domain(domain);
    //scale = chroma.scale(colors).domain([data.min, data.max]);
    // type 1: the higher the value, the darker the color
    //scale.mode('lch');
    //scale.correctLightness();
    // type 2:
    if (type === CLASSIFICATION_DISCRETE) {
      scale = scale.classes(count);
    }
    // type 3:
    else if (type === CLASSIFICATION_EQUIDISTANT) {
      let interval = dataSeries.unique(data.series).reverse();
      interval = chroma.limits(interval, 'q', interval.length);
      /*      for (let i = 1; i < 100; i++) {
              domain.push(data.min + step * i)
            }*/
      scale = scale.classes(interval);
      //scale = scale.classes(count);
    }

    return {
      scale: scale,
      type: type
    };
  },

  /**
   * Return the color stops for a gradient of only positive numbers.
   * @return {(string)[]} array of color stops in hex notation
   * @private
   */
  _getPositive () {
    const color = config.color.legend;

    return [color.posMin, color.posMed, color.posMax];
  },

  /**
   * Return the color stops for a gradient of only negative numbers.
   * @return {(string)[]} array of color stops in hex notation
   * @private
   */
  _getNegative () {
    const color = config.color.legend;

    return [color.negMax, color.negMed, color.negMin];
  },

  /**
   * Return the color stops for a gradient of positive and negative numbers.
   * @see https://gka.github.io/palettes/#/102|d|8f2c8f,ec71ec,ffe1ff|d9f2ec,50c5a7,006268|1|1 and
   *    http://www.vis4.net/blog/mastering-multi-hued-color-scales/
   * @return {(string)[]} array of color stops in hex notation
   * @private
   */
  _getMixed () {
    //return ['#8f2c8f', '#922f92', '#963196', '#993499', '#9c379c', '#a03a9f', '#a33da3', '#a640a6', '#a943a9', '#ac46ac', '#af49af', '#b34cb2', '#b64fb5', '#b952b8', '#bc56bb', '#be59be', '#c15cc1', '#c45fc3', '#c763c6', '#ca66c9', '#cc6acb', '#cf6dce', '#d171d0', '#d474d3', '#d678d5', '#d97cd8', '#db7fda', '#de83dc', '#e087de', '#e28ae0', '#e48ee3', '#e692e5', '#e896e7', '#ea9ae8', '#ec9eea', '#eea2ec', '#f0a6ee', '#f1aaef', '#f3aef1', '#f4b2f3', '#f6b6f4', '#f7baf5', '#f8bef7', '#f9c3f8', '#fbc7f9', '#fccbfa', '#fcd0fb', '#fdd4fc', '#fed8fd', '#ffddfe', '#d3f0e8', '#ccede5', '#c6ebe1', '#c0e8dd', '#bae6da', '#b5e3d7', '#afe1d3', '#a9ded0', '#a4dbcd', '#9fd8ca', '#9ad6c6', '#95d3c3', '#90d0c0', '#8bcdbd', '#86caba', '#81c7b7', '#7dc5b5', '#78c2b2', '#74bfaf', '#70bcac', '#6bb9aa', '#67b6a7', '#63b3a4', '#5fb0a2', '#5bad9f', '#57aa9d', '#53a79a', '#50a498', '#4ca195', '#489e93', '#459b91', '#41988e', '#3e958c', '#3a928a', '#378f87', '#338c85', '#308983', '#2d8681', '#29837f', '#26807c', '#237d7a', '#1f7a78', '#1c7776', '#187474', '#157172', '#116e70', '#0d6b6e', '#08686c', '#04656a', '#006268'];
    const color = config.color.legend;

    return [
      color.negMax,
      color.negMed,
      color.negMin,
      color.posMin,
      color.posMed,
      color.posMax
    ];
  }
};